/* ============================================================
   SHINE & STYLE — gift-set builder

   The bundle cards used to be three prices and a dead link. This
   makes them work: pick the pieces, add them all in one request.

   No bundle products are invented. Each set is simply N real items
   added to the cart, and the store's existing quantity discount
   ("Buy 2 get 10% off, buy 3 get 15%") applies at checkout. That
   keeps the maths honest — the discount is the store's own rule,
   not a number written into a card.
   ============================================================ */
(function () {
  'use strict';

  var dialog = document.querySelector('[data-bundle-dialog]');
  if (!dialog) return;

  var grid = dialog.querySelector('[data-bundle-grid]');
  var titleOut = dialog.querySelector('[data-bundle-title]');
  var countOut = dialog.querySelector('[data-bundle-count]');
  var totalOut = dialog.querySelector('[data-bundle-total]');
  var addButton = dialog.querySelector('[data-bundle-add]');
  var hintOut = dialog.querySelector('[data-bundle-hint]');

  var need = 3;
  var chosen = [];   // { id, price, title }

  function money(cents) {
    var f = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, amount)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function refresh() {
    if (countOut) countOut.textContent = chosen.length + ' / ' + need;

    var total = chosen.reduce(function (sum, item) { return sum + item.price; }, 0);
    if (totalOut) totalOut.textContent = money(total);

    if (addButton) {
      addButton.disabled = chosen.length === 0;
      addButton.textContent = addButton.getAttribute('data-label')
        .replace('{n}', chosen.length);
    }

    if (hintOut) {
      // Mirror the store's own quantity discount rather than inventing one.
      if (chosen.length >= 3) hintOut.textContent = hintOut.getAttribute('data-h3');
      else if (chosen.length === 2) hintOut.textContent = hintOut.getAttribute('data-h2');
      else hintOut.textContent = hintOut.getAttribute('data-h1');
    }

    Array.prototype.forEach.call(grid.querySelectorAll('[data-bundle-pick]'), function (btn) {
      var id = btn.getAttribute('data-variant');
      var on = chosen.some(function (c) { return c.id === id; });
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.closest('.ss-bpick').classList.toggle('is-picked', on);
    });
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-bundle-open]'), function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      need = parseInt(btn.getAttribute('data-bundle-need'), 10) || 3;
      chosen = [];
      if (titleOut) titleOut.textContent = btn.getAttribute('data-bundle-name') || '';
      refresh();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
  });

  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-pick]');
    if (!btn) return;

    var id = btn.getAttribute('data-variant');
    var at = chosen.findIndex(function (c) { return c.id === id; });

    if (at > -1) {
      chosen.splice(at, 1);
    } else {
      // Replace the oldest pick once the set is full, so the shopper
      // never has to deselect before choosing something else.
      if (chosen.length >= need) chosen.shift();
      chosen.push({
        id: id,
        price: parseInt(btn.getAttribute('data-price'), 10) || 0,
        title: btn.getAttribute('data-title') || ''
      });
    }
    refresh();
  });

  Array.prototype.forEach.call(dialog.querySelectorAll('[data-bundle-close]'), function (btn) {
    btn.addEventListener('click', function () {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    });
  });

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog && typeof dialog.close === 'function') dialog.close();
  });

  if (addButton) {
    addButton.addEventListener('click', function () {
      if (!chosen.length) return;

      addButton.disabled = true;
      var original = addButton.textContent;
      addButton.textContent = addButton.getAttribute('data-adding') || 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: chosen.map(function (c) { return { id: Number(c.id), quantity: 1 }; })
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (typeof dialog.close === 'function') dialog.close();

          var count = document.querySelector('[data-cart-count]');
          if (count) {
            count.textContent = String((parseInt(count.textContent, 10) || 0) + chosen.length);
            count.classList.remove('is-bump');
            void count.offsetWidth;
            count.classList.add('is-bump');
          }

          // The cart drawer is the confirmation that it worked.
          var open = document.querySelector('[data-cart-open]');
          if (open) open.click();
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .then(function () {
          addButton.disabled = false;
          addButton.textContent = original;
        });
    });
  }

  refresh();
})();
